import type { Sequence } from "@pdfking/tfunc"
import { Map, RecordCreate } from "@pdfking/tfunc"

import type { PrimaryKey } from "#public"

/** Build `Record<id, entry>` from a sequence of {@link PrimaryKey} entities (id is not repeated as a map key). */
export const RecordByPrimaryKey = <V extends PrimaryKey<PropertyKey>>(
  items: Sequence<V>
): Record<V["id"], V> =>
  RecordCreate(Map(item => [item.id, item] as const, items)) as Record<V["id"], V>
